import {
    Base
} from "//www.greenwellfarms.com/cdn/shop/t/53/assets/base.js?v=169946323862693207411733340615";
class Search extends Base {
    constructor() {
        super();
    }

    init(selector) {

        if ("undefined" === typeof selector || null === selector) return this;
        this.set("el", selector);
        return this.prep();

    } //

    prep() {
        let the_item = this.get("el"),
            search_button = the_item.querySelector(".search__button"),
            search_modal = the_item.querySelector(".search-modal");
     
        the_item.search_button = search_button;
        the_item.search_modal = search_modal;
        return this.bind_events();

    } // 

    bind_events() {
        let the_item = this.get("el"),
            search_button = the_item.search_button;


        search_button.addEventListener("click", this.handle_search_button_click.bind(this));
        return this;
    }

    handle_search_button_click() {
        let the_item = this.get("el"),
            search_modal = the_item.search_modal;

        if(search_modal.getAttribute("data-display") && search_modal.getAttribute("data-display") == 1){
            search_modal.setAttribute("data-display", -1);
        } else {
            search_modal.setAttribute("data-display", 1);
        }

        return this;
    }

}

export {
    Search
};